export default "__VITE_ASSET__e95b45eb__"